(function () {
  'use strict';

  angular
    .module('relatorios.videoLibrary.playback', [
      'ui.router',
      'FactoryVfiltroModule',
      'ServiceVfiltroModule',
      'ConstantVfiltroModule',
      'angularMoment',
      'v3gAuthenticatorModule',
      'pascalprecht.translate'
    ]);
}());
